let formatter = new Intl.NumberFormat()

let formatNumber = function(number) {
  return formatter.format(number)
}

export { formatNumber }
